const SSOActions = {
  SET_SSO_PARAMS: 'SSOActions.SET_SSO_PARAMS',
};

export default SSOActions;
